var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6639 15.2649C14.6447 15.2022 14.6313 15.1378 14.6209 15.0727C14.6161 15.0426 14.6106 15.0127 14.6043 14.9829C14.5906 14.9182 14.5754 14.8539 14.5589 14.79C14.8314 14.3603 16.1342 12.119 14.6518 10.6805C13.0064 9.084 11.0839 11.1766 11.0839 11.1766L11.0899 11.1859C10.2258 10.9124 9.28892 10.8803 8.37739 11.1765C8.36613 11.1642 6.44999 9.08869 4.80949 10.6805C3.16847 12.2728 4.94051 14.8489 4.94978 14.8624C4.93089 14.9229 4.91566 14.9849 4.90561 15.0477C4.72809 16.15 3.51953 16.4902 3.51953 18.4105C3.51953 20.3307 4.78385 21.9101 7.36446 21.9101H8.42337C8.42813 21.9172 8.86424 22.5608 9.75947 22.5601C10.5906 22.5595 11.1394 21.9156 11.1442 21.9101H12.1546C14.7352 21.9101 15.9995 20.3677 15.9995 18.4105C15.9995 16.6223 14.9513 16.2043 14.6639 15.2649Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.47 19.0495C18.3583 19.0495 17.4531 18.1443 17.4531 17.0326V15.0774C17.4531 13.9657 18.3583 13.0605 19.47 13.0605C20.5817 13.0605 21.4869 13.9657 21.4869 15.0774V17.0326C21.4859 18.1453 20.5817 19.0495 19.47 19.0495ZM19.47 14.1611C18.9648 14.1611 18.5537 14.5722 18.5537 15.0774V17.0326C18.5537 17.5378 18.9648 17.9489 19.47 17.9489C19.9753 17.9489 20.3863 17.5378 20.3863 17.0326V15.0774C20.3863 14.5722 19.9753 14.1611 19.47 14.1611Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.47 12.2409C18.3583 12.2409 17.4531 11.3357 17.4531 10.224V8.26885C17.4531 7.15713 18.3583 6.25195 19.47 6.25195C20.5817 6.25195 21.4869 7.15713 21.4869 8.26885V10.224C21.4859 11.3357 20.5817 12.2409 19.47 12.2409ZM19.47 7.35153C18.9648 7.35153 18.5537 7.7626 18.5537 8.26784V10.224C18.5537 10.7292 18.9648 11.1403 19.47 11.1403C19.9753 11.1403 20.3863 10.7292 20.3863 10.224V8.26885C20.3863 7.7626 19.9753 7.35153 19.47 7.35153Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.47 25.8942C18.3583 25.8942 17.4531 24.9891 17.4531 23.8773V21.9212C17.4531 20.8095 18.3583 19.9043 19.47 19.9043C20.5817 19.9043 21.4869 20.8095 21.4869 21.9212V23.8763C21.4859 24.9891 20.5817 25.8942 19.47 25.8942ZM19.47 21.0049C18.9648 21.0049 18.5537 21.416 18.5537 21.9212V23.8763C18.5537 24.3816 18.9648 24.7926 19.47 24.7926C19.9753 24.7926 20.3863 24.3816 20.3863 23.8763V21.9212C20.3863 21.416 19.9753 21.0049 19.47 21.0049Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4697 21.9835C19.166 21.9835 18.9199 21.7375 18.9199 21.4337V17.5224C18.9199 17.2187 19.166 16.9727 19.4697 16.9727C19.7735 16.9727 20.0195 17.2187 20.0195 17.5224V21.4337C20.0195 21.7365 19.7735 21.9835 19.4697 21.9835Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4697 15.1388C19.166 15.1388 18.9199 14.8928 18.9199 14.589V10.6767C18.9199 10.373 19.166 10.127 19.4697 10.127C19.7735 10.127 20.0195 10.373 20.0195 10.6767V14.588C20.0195 14.8918 19.7735 15.1388 19.4697 15.1388Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6966 22.3913C23.5849 22.3913 22.6797 21.4861 22.6797 20.3744V18.4192C22.6797 17.3075 23.5849 16.4023 24.6966 16.4023C25.8083 16.4023 26.7135 17.3075 26.7135 18.4192V20.3744C26.7135 21.4871 25.8083 22.3913 24.6966 22.3913ZM24.6966 17.5029C24.1913 17.5029 23.7803 17.914 23.7803 18.4192V20.3744C23.7803 20.8796 24.1913 21.2907 24.6966 21.2907C25.2018 21.2907 25.6129 20.8796 25.6129 20.3744V18.4192C25.6139 17.914 25.2018 17.5029 24.6966 17.5029Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6956 17.2988C24.1904 17.2988 23.7793 17.7099 23.7793 18.2151V18.4176C23.7793 17.9124 24.1904 17.5013 24.6956 17.5013C25.2008 17.5013 25.6119 17.9124 25.6119 18.4176V18.2151C25.6129 17.7099 25.2008 17.2988 24.6956 17.2988Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6966 15.5817C23.5849 15.5817 22.6797 14.6766 22.6797 13.5648V11.6087C22.6797 10.497 23.5849 9.5918 24.6966 9.5918C25.8083 9.5918 26.7135 10.497 26.7135 11.6087V13.5638C26.7135 14.6766 25.8083 15.5817 24.6966 15.5817ZM24.6966 10.6924C24.1913 10.6924 23.7803 11.1035 23.7803 11.6087V13.5638C23.7803 14.0691 24.1913 14.4801 24.6966 14.4801C25.2018 14.4801 25.6129 14.0691 25.6129 13.5638V11.6087C25.6139 11.1035 25.2018 10.6924 24.6966 10.6924Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6963 25.3253C24.3925 25.3253 24.1465 25.0793 24.1465 24.7755V20.8642C24.1465 20.5605 24.3925 20.3145 24.6963 20.3145C25 20.3145 25.2461 20.5605 25.2461 20.8642V24.7755C25.2461 25.0783 25 25.3253 24.6963 25.3253Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6963 18.4806C24.3925 18.4806 24.1465 18.2346 24.1465 17.9308V14.0185C24.1465 13.7148 24.3925 13.4688 24.6963 13.4688C25 13.4688 25.2461 13.7148 25.2461 14.0185V17.9298C25.2461 18.2336 25 18.4806 24.6963 18.4806Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_89918_88070",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 14,
    height: 14
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 9.59961H28.4795V22.5596H15.5195V9.59961Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_89918_88070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6963 11.6847C24.3925 11.6847 24.1465 11.4387 24.1465 11.1349V7.22362C24.1465 6.91987 24.3925 6.67383 24.6963 6.67383C25 6.67383 25.2461 6.91987 25.2461 7.22362V11.1349C25.2461 11.4376 25 11.6847 24.6963 11.6847Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbera);
export default __webpack_public_path__ + "static/media/abera.f7d3a3829d8902f66b5e4b3bca236ed9.svg";
export { ForwardRef as ReactComponent };